import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SiteButton from "../ui/SiteButton";
import heroArt from "../../assets/imgs/MubeginningLogo.png";
import divider from "../../assets/imgs/ui/decorations/separator-1.png";
import { useLang } from "../../i18n/LangContext";
import "./Hero.scss";

const Hero = () => {
  const navigate = useNavigate();
  const { t } = useLang();
  const user = useSelector((state) => state.reducerUser.userLogin);
  const isAuthed = user?.status === "fulfilled";

  return (
    <section className="mu-hero">
      <div className="mu-hero__art">
        <img src={heroArt} alt="" />
      </div>
      <div className="mu-hero__content">
        <h1 className="mu-hero__title">
          MU BEGINNING
          <span>THE LEGEND CONTINUES</span>
        </h1>
        <div className="mu-hero__subtitle">
          <img src={divider} alt="" className="mu-hero__divider" />
          <span className="mu-hero__subtitle-text">SEASON 6 LAUNCH</span>
        </div>
        <div className="mu-hero__actions">
          <SiteButton
            variant="primary"
            onClick={() => navigate(isAuthed ? "/profile" : "/register")}
          >
            {t("play_now")}
          </SiteButton>
          <SiteButton variant="secondary" to="/download">
            {t("download_client")}
          </SiteButton>
        </div>
      </div>
    </section>
  );
};

export default Hero;
